<!-- Menu de secciones -->
<div class="row" *ngIf="menu.color" style="min-height: 70vh;">
  <div class="col-12 mb-2" *ngFor="let section of menu.sections; let index = index" [id]="section.name + 'section'" [hidden]="section.type === TYPE_SECTIONS.additions">
    <!-- Nombre de la seccion -->
    <div class="row justify-content-center p-2" *ngIf="section.type !== TYPE_SECTIONS.gallery && section.type !== TYPE_SECTIONS.videos">
      <div class="col-12 rounded" *ngIf="!section.photo && section.type !== TYPE_SECTIONS.gallery && section.type !== TYPE_SECTIONS.videos"
        [ngStyle]="{'background': setBackground(section)}">
        <h1 [ngClass]="{'additions': section.type === TYPE_SECTIONS.productList}"
          class="meal-title font-weight-bold {{menu.fontSections? menu.fontSections: menu.fontHeader}} p-2 justify-content-center" [ngStyle]="{'color': setColorText(section)}"
          translate="no">
          <ng-container *ngIf="language === 'ES'">
            {{ section.name | uppercase }}
          </ng-container>
          <ng-container *ngIf="language === 'EN'">
            {{ section.nameEn | uppercase }}
          </ng-container>
        </h1>
      </div>
      <!-- Foto de la seccion  con texto puesto por eazzy-->
      <div class="col-12 align-items-center justify-content-center d-flex" *ngIf="section.photo && section.text">
        <h1 class="{{menu.fontSections? menu.fontSections: menu.fontHeader}} font-weight-bold position-absolute section-name animate__animated animate__delay-2s fadeIn"
          style="color: white; z-index:1">
          {{ language === 'ES'? section.name: section.nameEn}}</h1>
        <img [src]="section.photo" [id]="section.photo" [defaultImage]="bannerImage" [lazyLoad]="section.photo" loading="lazy" class="img-fluid animate__animated rounded"
          style="width: 100%;">
      </div>
      <!-- Foto de la seccion sin texto-->
      <div class="col-12" *ngIf="section.photo && !section.text">
        <img [src]="section.photo" [id]="section.photo" [defaultImage]="bannerImage" [lazyLoad]="section.photo" loading="lazy" class="img-fluid animate__animated"
          style="width: 100%;">
      </div>
    </div>
    <div class="row">
      <div class="col">
        <!-- Descripcion de la seccion -->
        <div class="justify-content-center text-center d-flex text-center p-2" *ngIf="section.description || section.descriptionEn">
          <p [ngStyle]="{'color': menu.colorText}" class="mb-3 {{menu.fontText}} font-weight-bold" *ngIf="language === 'ES'" [innerHTML]="section.description">
          </p>
          <p [ngStyle]="{'color': menu.colorText}" class="mb-3 {{menu.fontText}} font-weight-bold" *ngIf="language === 'EN'" [innerHTML]="section.descriptionEn">
          </p>
        </div>
      </div>
    </div>
    <!-- Secciones -->
    <div class="row body justify-content-center" [ngStyle]="{'background': 'transparent'}">

      <!-- Items de secciones con foto -->
      <app-item-image [section]="section" [menu]="menu" class="w-100" *ngIf="section.type === TYPE_SECTIONS.productsMenu|| section.type === TYPE_SECTIONS.productsOnlyPhoto">
      </app-item-image>

      <!-- Items de secciones con o sin logo en modo listado -->
      <app-item-list *ngIf="section.type === TYPE_SECTIONS.productList" [section]="section" [menu]="menu" class="w-100">
      </app-item-list>

      <!-- Items de secciones en modo listado simple -->
      <app-item-simple-list *ngIf="section.type === TYPE_SECTIONS.productSimpleList" [section]="section" [menu]="menu" class="w-100">
      </app-item-simple-list>
      <!-- Items de secciones de listado solo con descripciones -->
      <app-item-only-description [section]="section" [menu]="menu" *ngIf="section.type === TYPE_SECTIONS.onlyDescription" class="w-100"></app-item-only-description>
      <!-- Items de secciones de bebidas alcoholicas -->
      <app-item-drinks *ngIf="section.type === TYPE_SECTIONS.drinks || section.type === TYPE_SECTIONS.wines" [section]="section" [menu]="menu" class="w-100">
      </app-item-drinks>

      <!-- Items de secciones de bebidas alcoholicas -->
      <app-item-drink-midle *ngIf="section.type === TYPE_SECTIONS.drinks_midle" [section]="section" [menu]="menu" class="w-100">
      </app-item-drink-midle>
      <!-- Items de secciones de galeria de imagenes -->
      <app-item-gallery [section]="section" *ngIf="section.type === TYPE_SECTIONS.gallery"></app-item-gallery>
      <!-- Items de secciones de galeria de videos -->
      <app-item-video [section]="section" *ngIf="section.type === TYPE_SECTIONS.videos"></app-item-video>
      <!-- Items de secciones de adiciones -->
      <app-item-list-additions *ngIf="menu.sections[index + 1]?.type === TYPE_SECTIONS.additions" [section]="menu.sections[index + 1]" [menu]="menu" class="w-100">
      </app-item-list-additions>
    </div>

  </div>
</div>
<div class="row mb-7">
  <div class="col-12">
    <app-menu-selectors [menu]="menu"></app-menu-selectors>
  </div>
</div>